var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { BackgroundProvider } from '../BackgroundContext/index.js';
import { BleedProvider } from '../Bleed/BleedContext.js';
import { CardProvider, useCard } from './CardContext.js';
import { CardActions, CardFooter } from './CardFooter.js';
import { CardHeader } from './CardHeader.js';
const CardWithRef = forwardRef((_a, ref) => {
    var { as, children, className, transparent = false, padding = 'md', attached = 'none' } = _a, rest = __rest(_a, ["as", "children", "className", "transparent", "padding", "attached"]);
    let attachedClsx = 'sm:rounded-lg';
    if (attached === 'top') {
        attachedClsx = 'sm:rounded-b-lg';
    }
    if (attached === 'bottom') {
        attachedClsx = 'sm:rounded-t-lg';
    }
    if (attached === 'left') {
        attachedClsx = 'sm:rounded-e-lg';
    }
    if (attached === 'right') {
        attachedClsx = 'sm:rounded-s-lg';
    }
    if (attached === 'all') {
        attachedClsx = '';
    }
    const Component = as || 'div';
    return (React.createElement(Component, Object.assign({ ref: ref, className: twMerge(clsx(!transparent && 'bg-surface text-content-subdued shadow', 'flex flex-col justify-between', attachedClsx, className)) }, rest),
        React.createElement(CardProvider, { padding: padding },
            React.createElement(BackgroundProvider, { backgroundType: "surface" }, children))));
});
const CardContent = (_a) => {
    var { children, className, withBleed = false } = _a, rest = __rest(_a, ["children", "className", "withBleed"]);
    const { padding } = useCard();
    return (React.createElement("div", Object.assign({ className: twMerge(clsx('flex-1', padding === 'md' && 'px-4 py-5 sm:p-6', padding === 'sm' && 'px-4 py-5 sm:px-3', className)) }, rest), withBleed ? (React.createElement(BleedProvider, { bleedClassName: clsx(padding === 'md' && '-ms-4 -me-4 sm:-mx-6', padding === 'sm' && '-ms-4 -me-4 sm:-mx-3') }, children)) : (children)));
};
const CardMedia = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: className }, rest), children));
};
export const Card = Object.assign(Object.assign({}, CardWithRef), { Header: CardHeader, Content: CardContent, Footer: CardFooter, Media: CardMedia, Actions: CardActions });
//# sourceMappingURL=Card.js.map